import { Layout } from '@uhg-abyss/web/ui/Layout';
import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
import CustomeRowAdd from '../CustomeRowAdd';
import { useSelector } from 'react-redux';
import { getThelistData } from '@src/utils';
import { LABELS, MODELS, dSystems } from '@src/constants';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
export const CustomerAndVendorDemographics = ({ types }) => {
  return (
    <>
      <Table.Container title="">
        <Table.TableBody>

          <CustomeRowAdd
            label="OE Effective Date"
            model="demographics.openEnrollmentDate"
            placeHolder={"01/01"}
          />

          <Table.Row css={{ height: '26px' }}>
            <Table.Cell>
              <strong>{LABELS.DOMESTIC_STREET_ADDRESS_1}</strong>
            </Table.Cell>
            <Table.Cell></Table.Cell>
          </Table.Row>
          <Table.Row css={{ height: '26px' }}>
            <Table.Cell>
              <strong>{LABELS.DOMESTIC_CITY}</strong>
            </Table.Cell>
            <Table.Cell></Table.Cell>
          </Table.Row>

          <CustomeRowAdd
            label={'Email Notification'}
            model={'demographics.emailNotificationCode'}
            type={'select'}
            options={types}
          />
        </Table.TableBody>
      </Table.Container>
      <Table.Container title="">
        <Table.TableBody>
          <CustomeRowAdd
            label="Earliest Start Date"
            model="demographics.earliestStartDate"
            type={'date'}
          />
          <Table.Row css={{ height: '26px' }}>
            <Table.Cell><strong>{LABELS.DOMESTIC_STREET_ADDRESS_2}</strong></Table.Cell>
            <Table.Cell></Table.Cell>
          </Table.Row>
          <Table.Row css={{ height: '26px' }}>
            <Table.Cell><strong>{LABELS.DOMESTIC_STATE_CODE}</strong></Table.Cell>
            <Table.Cell></Table.Cell>
          </Table.Row>
          <Table.Row css={{ height: '26px' }}>
            <Table.Cell></Table.Cell>
            <Table.Cell></Table.Cell>
          </Table.Row>
        </Table.TableBody>
      </Table.Container>
      <Table.Container title="">
        <Table.TableBody>
          <Table.Row css={{ height: '26px' }}>
            <Table.Cell><strong>{LABELS.PRE_EXISTING_INDICATOR}</strong></Table.Cell>
            <Table.Cell></Table.Cell>
          </Table.Row>
          <Table.Row css={{ height: '26px' }}>
            <Table.Cell>
              <strong>{LABELS.ENROLL_REASON_REQUIRED}</strong>
            </Table.Cell>
            <Table.Cell></Table.Cell>
          </Table.Row>
          <Table.Row css={{ height: '26px' }}>
            <Table.Cell>
              <strong>{LABELS.DOMESTIC_POSTAL_CODE}</strong>
            </Table.Cell>
            <Table.Cell></Table.Cell>
          </Table.Row>
          <Table.Row css={{ height: '26px' }}>
            <Table.Cell>
              <strong></strong>
            </Table.Cell>
            <Table.Cell></Table.Cell>
          </Table.Row>
        </Table.TableBody>
      </Table.Container>
    </>
  )
}
const AddDemographics = () => {
  const form = useForm()
  const dropDownData = useSelector((state) => state?.listOfValues?.data);
  const { emailNotifyTypes, reasonCodes, stateCodes } = dropDownData
  const destination = form.watch("customerDetails.destinationSystem");
  const profileType = form.watch('customerDetails.profileType')

  return (
    <>
      <Layout.Group
        css={{
          alignItems: 'start',
          '.abyss-table-cell': {
            paddingTop: '2px',
            paddingBottom: '2px',
          },
        }}
        grow
      >{destination === '8' && profileType === '3' &&
        <>
          <Table.Container title="">
            <Table.TableBody>

              <CustomeRowAdd
                label={LABELS.OE_EFFECTIVE_DATE}
                model={MODELS.OE_EFFECTIVE_DATE}

              />
              <CustomeRowAdd
                label={LABELS.DOMESTIC_STREET_ADDRESS_1}
                model={MODELS.DOMESTIC_STREET_ADDRESS_1}

              />
              <CustomeRowAdd
                label={LABELS.DOMESTIC_CITY}
                model={MODELS.DOMESTIC_CITY}


              />




            </Table.TableBody>
          </Table.Container>
          <Table.Container title="">
            <Table.TableBody>
              <CustomeRowAdd
                label={LABELS.EARLIEST_START_DATE}
                model={MODELS.EARLIEST_START_DATE}
                type={'date'}
              />
              <CustomeRowAdd
                label={LABELS.DOMESTIC_STREET_ADDRESS_2}
                model={MODELS.DOMESTIC_STREET_ADDRESS_2}

              />
              <CustomeRowAdd
                label={LABELS.DOMESTIC_STATE_CODE}
                model={MODELS.DOMESTIC_STATE_CODE}
                type={'select'}
                options={stateCodes}

              />

            </Table.TableBody>
          </Table.Container>
          <Table.Container title="">
            <Table.TableBody>
              <CustomeRowAdd
                label={LABELS.PRE_EXISTING_INDICATOR}
                model={MODELS.PRE_EXISTING_INDICATOR}
                options={reasonCodes}
                type={'select'}

              />
              <CustomeRowAdd
                label={LABELS.ENROLL_REASON_REQUIRED}
                model={MODELS.ENROLL_REASON_REQUIRED}
                options={reasonCodes}
                type={'select'}

              />
              <Table.Row>
                <Table.Cell>
                  <strong>{LABELS.DOMESTIC_POSTAL_CODE}</strong>
                </Table.Cell>
               <Table.Cell
                              css={{
                                padding: '0!important',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent:'center',
                                  alignItems:'center'

                                }}
                              >
                                <Layout.Group>
                                 <TextInput label=""  model={'demographics.domesticPostalCode'}  maxLength={5} />

                                -
                                <TextInput label="" model={'demographics.domesticPostalExtensionCode'}  maxLength={4} />
                                </Layout.Group>

                              </div>
                            </Table.Cell>
                            </Table.Row>
             {/* {  <CustomeRowAdd
                label={LABELS.DOMESTIC_POSTAL_CODE}
                model={MODELS.DOMESTIC_POSTAL_CODE}

              /> */}



            </Table.TableBody>
          </Table.Container>
        </>
        }
        {(destination === '8' || destination === '') && (profileType === '2' || profileType === '1' || profileType === "") &&
          <CustomerAndVendorDemographics types={emailNotifyTypes} />}
      </Layout.Group>
    </>
  );
};

export default AddDemographics;
